export const ANNOTATION_FULL_STYLE = 1
export const ANNOTATION_UNDERLINE_STYLE = 2

// View options for media content
export const VIEW_OPTIONS = {
  grid: 'grid',
  list: 'list',
}

// Sorting options for media content
export const SORT_OPTIONS = {
  recentlyAdded: 'Recently Added',
  // recentlyOpened: 'Recently Opened',
  // notStarted: 'Not Started',
  title: 'Title',
  author: 'Author',
  // releaseDate: 'Release Date',
}

// Filter options for media content
export const FILTER_OPTIONS = {
  bookshelfPlus: 'Bookshelf +',
  new: 'New',
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  finished: 'Finished',
}

// Tab options for media content
export const TABS = {
  all: 'all',
  ebook: 'ebook',
  audiobook: 'audiobook',
}
